import React, { createContext, useContext, useEffect, useState } from "react";
import { loadClientConfig } from "../services/clientConfigService";

const ConfigContext = createContext();
export const useAppConfig = () => useContext(ConfigContext);

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);

  useEffect(() => {
    loadClientConfig().then(setConfig).catch((err) => {
      console.error("Failed to load client config", err);
    });
  }, []);

  if (!config) return <div>Loading configuration...</div>;

  return (
    <ConfigContext.Provider value={config}>
      {children}
    </ConfigContext.Provider>
  );
};
